module.exports = __webpack_public_path__ + "img/96.4f6de81e.jpg";